<template>
    <v-container class="my-5">
      <!--  Dialogo para mostrar Detalles del Comunicado   -->
      <v-dialog v-model="dialogView" scrollable max-width="700">
        <v-card class="elevation-5">
          <v-toolbar dark color="primary">
            <v-toolbar-title>
              {{itemDetail.title}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                class="align-self-end"
                color="red"
                icon
                @click="dialogView = false"
            ><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-title></v-card-title>
          <v-card-text>
            <div class="heading text-justify"><p><strong>{{itemDetail.comments}}</strong></p></div>
<!--            <v-img-->
<!--                v-if="itemDetail.file && extensionImage(itemDetail.file) === true"-->
<!--                :src="itemDetail.file"-->
<!--            ></v-img>-->
            <embed
                width="100%"
                height="1000px"
                :src="itemDetail.file"/>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
                @click="newPage(itemDetail.file)"
                v-if="itemDetail.file && extensionImage(itemDetail.file) === true"
                color="primary">
              <v-icon>mdi-file-image</v-icon>{{$t('descargar')}}
            </v-btn>
            <v-btn
                @click="newPage(itemDetail.file)"
                v-else-if="itemDetail.file && extensionImage(itemDetail.file) === false"
                color="primary">
              <v-icon>mdi-file-pdf-box </v-icon>{{$t('descargar')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Comunicado     -->
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_financial_statements')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteNotice()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('financial_statements')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="450">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                v-if="getProfile.role === 1"
                                color="primary"
                                v-on="on"
                                @click="change = false, update = false, cleanFields()"
                        >
                            + {{$t('add_financial_statements')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                            ? updateNotice(idUpdate)
                            : addNotice()"
                >
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('financial_statements')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-text-field
                                    v-if="dialog" autofocus
                                    v-model="title"
                                    name="title"
                                    counter
                                    maxlength="100"
                                    prepend-icon="mdi-format-title"
                                    :label="'*' + $t('title')"
                                    :error-messages="errores.title"
                            ></v-text-field>
                            <v-textarea
                                    v-model="comments"
                                    name="comments"
                                    counter
                                    maxlength="300"
                                    prepend-icon="mdi-comment-edit"
                                    :label="$t('comments')"
                                    :error-messages="errores.comments"
                            ></v-textarea>
                            <v-checkbox
                                    v-model="change"
                                    name="change"
                                    :label="update === false ? $t('agregar') + ' '+ $t('file') : $t('modificar') + ' '+ $t('file')"
                            ></v-checkbox>
                            <v-file-input
                                v-model="file"
                                :disabled="!change"
                                :rules="rules"
                                accept=".pdf"
                                placeholder="pdf"
                                prepend-icon="mdi-paperclip"
                                @change="oversized_function"
                                :error-messages="errores.file"
                                :label="update && file !== null ? $t('file'): $t('modificar')"
                            ></v-file-input>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :disabled="oversized" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" :disabled="oversized" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
          <v-container fluid>
            <v-row dense>
              <v-col
                  v-for="notice in notices"
                  :key="notice.title"
                  cols="6"
              >
                <v-card color="primary">
                  <v-card-title class="white--text">
                    {{notice.title}}
                  </v-card-title>
                  <v-card-subtitle class="white--text">
                    {{notice.comments}}
                  </v-card-subtitle>
                  <v-card-text>
                    <embed
                        class="white--text align-start"
                        width="100%"
                        height="200px"
                        :src="notice.file"
                        gradient="to top right, rgba(0,0,0,.7), rgba(25,32,72,.9)"
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-if="getProfile.role === 1"
                            v-bind="attrs"
                            v-on="on"
                            large
                            color="white"
                            class="mr-2"
                            @click="fillFields(notice), update = true, dialog = true, change = false, idUpdate = notice.id"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>{{$t('change')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-if="getProfile.role === 1"
                            v-bind="attrs"
                            v-on="on"
                            large
                            color="red"
                            class="mr-2"
                            @click="deleteDialog = true, idNoticeDelete = notice.id"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>{{$t('delete')}}</span>
                    </v-tooltip>
                    <v-btn icon>
                      <v-icon color="white" large @click="itemDetail = notice, newPage(itemDetail.file)">mdi-eye</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'financial_statements',
  created () {
    this.getNotices()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    title: '',
    comments: '',
    titleAux: '',
    commentsAux: '',
    loadingDataNotices: false,
    loading: false,
    notices: [],
    errores: [],
    idUpdate: 0,
    idNoticeDelete: 0,
    deleteDialog: false,
    file: null,
    update: false,
    change: false,
    rules: [],
    oversized: false,
    dialogView: false,
    itemDetail: {
      id: '',
      title: '',
      file: '',
      comments: ''
    }
  }),
  beforeUpdate () {
    this.rules = [
      value => !value || value.size < 2000000 || this.$t('msg_overflow_file')
    ]
  },
  methods: {
    newPage (url) {
      window.open(url, '_blank')
    },
    oversized_function (value) {
      console.log('Valor Archivo = ', value)
      if (value !== null) {
        if (value.size > 2048 * 1024) {
          this.oversized = true
        } else {
          this.oversized = false
        }
        console.log('ERoores = ', this.errores.file)
        if (this.change === true && this.errores.file) {
          this.errores.file = ''
        }
      } else {
        this.oversized = false
      }
    },
    getNotices () {
      this.loadingDataNotices = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/notice_create_get/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.notices = response.data
          this.loadingDataNotices = false
        })
        .catch(error => {
          this.loadingDataNotices = false
          console.log(error)
        })
    },
    addNotice () {
      console.log('File = ', this.file)
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      bodyFormData.set('idHousingUnit', this.getProfile.idHousingUnit)
      bodyFormData.set('title', this.title)
      if (this.comments !== '') {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('file', this.file)
      }
      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/notice_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_added_financial_statement'))
          this.dialog = false
          this.getNotices()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    updateNotice (id) {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()
      if (this.title !== this.titleAux) {
        bodyFormData.set('title', this.title)
      }
      if (this.comments !== this.commentsAux) {
        bodyFormData.set('comments', this.comments)
      }
      if (this.change === true) {
        bodyFormData.append('file', this.file)
      }
      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/notice_get_detail_and_update_it/' + id + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getNotices()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_financial_statement_updated'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
          }
        })
    },
    deleteNotice () {
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/notice_get_detail_and_update_it/' + this.idNoticeDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Notice con ID = ', this.idNoticeDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_financial_statement_deleted'))
        this.getNotices()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    cleanFields () {
      this.title = ''
      this.comments = ''
      this.file = null
      this.oversized = false
    },
    fillFields (item) {
      if (item.file !== null) {
        var fileAux = new File(['foo'], item.file)
        this.file = fileAux
      }
      this.title = item.title
      this.comments = item.comments
      this.titleAux = item.title
      this.commentsAux = item.comments
      this.oversized = false
    },
    clear: function () {
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    extensionImage (url) {
      if (url.includes('.png') || url.includes('.gif') || url.includes('.jpeg') || url.includes('.jpg')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>
